import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IListBySearchPayload } from '@app-store/slices/sourceCategories/listBySearch'

interface TaskAction extends Action {
    payload: IListBySearchPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.sourceCategories.listBySearch

// This saga is for getting list of companies
function* listBySearchSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/companies/source-categories/search?searchString=${payload.search}`)
        if (response.success) {
            yield put(onSuccess({ ...response.result }))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listBySearchSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listBySearchSagaTask)
}

export default listBySearchSaga
